import cn from 'classnames';
import { FC, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { Badge } from '@/shared/ui';

import styles from './DocumentRow.module.scss';

type HeaderProps = {
  title?: string;
  tag?: ReactNode;
  requirement?: 'always' | 'on_demand';
  children?: ReactNode;
  className?: string;
};

export const DocumentHeader: FC<HeaderProps> = ({
  title,
  tag,
  requirement,
  children,
  className,
}) => (
  <div className={cn(styles.header, className)}>
    {title && <h3 className="h6">{title}</h3>}
    {tag}
    {requirement && (
      <Badge size="small">
        {requirement === 'always' ? (
          <FormattedMessage
            id="workspace.document.required"
            defaultMessage="Required"
          />
        ) : (
          <FormattedMessage
            id="workspace.document.optional"
            defaultMessage="Additional"
          />
        )}
      </Badge>
    )}
    <span className={styles.spacer} />
    {children}
  </div>
);

type RowProps = {
  label: string;
  tag?: ReactNode;
  as?: 'div' | 'label';
  children: ReactNode;
  className?: string;
};

export const DocumentRow: FC<RowProps> = ({
  label,
  tag,
  as: Element = 'div',
  children,
  className,
}) => (
  <Element
    data-component="workspace-document-row"
    className={cn(styles.row, className)}
  >
    <span className={styles.labelColumn}>
      <span className={cn('h6', styles.label)}>{label}</span>
      {tag && <span className={styles.tag}>{tag}</span>}
    </span>
    <span className={styles.content}>{children}</span>
  </Element>
);
